import app from 'flarum/forum/app';
import Switch from 'flarum/common/components/Switch';
import withAttr from 'flarum/common/utils/withAttr';
import Field from './Field';
import RichTextField from '../components/RichTextField';

export default class LongAnswer extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'min',
            'max',
            'rich',
        ]);
    }

    configure() {
        return [
            this.minMaxRules(),
            m('.Form-group', [
                Switch.component({
                    state: this.getConfig('rich', false),
                    onchange: this.setConfig('rich'),
                    disabled: this.disabled,
                }, app.translator.trans('kilowhat-formulaire.forum.template-editor.rich')),
            ]),
        ];
    }

    fill() {
        const attrs = {
            id: this.uniqueFieldId(),
            className: this.validationErrorsForThisField() ? 'in-error' : '',
            value: this.getSubmission(),
            oninput: withAttr('value', this.setSubmission.bind(this)),
            disabled: this.isFillDisabled(),
        };

        return [
            this.getConfig('rich') ? m(RichTextField, attrs) : m('textarea.FormControl', attrs),
            this.getConfig('max') ? m('.FormulaireTextLength', [
                m('span.FormulaireTextLengthValue', {
                    className: this.getSubmission().length > this.getConfig('max') ? 'FormulaireTextLengthValueTooLong' : '',
                }, this.getSubmission().length),
                '/' + this.getConfig('max'),
            ]) : null,
        ];
    }

    display() {
        if (this.getConfig('rich')) {
            const html = this.getSubmission('', 'html');

            if (html) {
                return m('div', m.trust(html));
            }
        }

        return super.display();
    }
}
